import { html } from "../lib/index.js";

export default function ActivityInbox(props) {
	return html`<div class="activity-inbox">
		<div class="activity-toolbar">
			<p class="activity-description">Recent mentions and private messages saved on this browser.</p>
			${props.entries.length > 0 && html`<button type="button" class="activity-clear" onClick=${() => {
				if (window.confirm("Clear saved activity on this browser?")) {
					props.onClear();
				}
			}}>Clear activity</button>`}
		</div>
		${props.error && html`<p class="activity-error" role="alert">${props.error}</p>`}
		${props.entries.length === 0 ? html`<p class="activity-empty">No recent activity.</p>` : html`
			<ul class="activity-results">
				${props.entries.map((entry) => html`<li key=${entry.id}>
					<button type="button" disabled=${Boolean(props.loading)} onClick=${() => props.onSelect(entry)}>
						<span class="activity-meta">
							<strong>${entry.bufferName}</strong>
							<span>${entry.networkName}</span>
							<time datetime=${entry.time} title=${new Date(entry.time).toLocaleString()}>
								${new Date(entry.time).toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}
							</time>
						</span>
						<span class="activity-body"><strong>${entry.nick}</strong> ${entry.text}</span>
						${entry.unread && html`<span class="activity-unread">Unread</span>`}
						${props.loading === entry.id && html`<span class="activity-loading">Loading conversation…</span>`}
					</button>
				</li>`)}
			</ul>`}
	</div>`;
}
